<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Payments</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Active Request</li>
              </ol>
            </div>
          </div>
        </div>
        <PatientsSearchComponent
          @apply-search-click="applySearchClick()"
          :called_by="'PaymentRequest_1'"
        ></PatientsSearchComponent>

          <CollectPayments  ref="cp" :AppModelId="16" :removeids="true">
          </CollectPayments>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
// import PatientComponent from "../views/Patients/PatientComponent.vue"; // $$**$$
import PatientsSearchComponent from "../views/VeinsTracker/PatientsSearchComponent.vue";
import CollectPayments from "./CollectPayments.vue";
export default {
  name: "PaymentRequest_1",

  // $$**$$
  components: {
    //PatientComponent,
    CollectPayments,
    PatientsSearchComponent
  },
  props:[
    "FetchTableData"
  ],
  data() {
    return {

      //loader
      loader: "",
     //Timer
      TimerObject: {},
      allPaymentRequests: "",
      filteredPaymentRequests: "",

      filter: {
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        monthYear: "",
        dateFull: "",
      },
 

      initDate: "",
      startDate: "",
      endDate: "",

      aSinglePayment: "",
      propPatientSource: { visitId: 0, patientId: 0, updButton: 1 }, //-- $$**$$
     
    };
  }, // data()

  methods: {
     //MethodType 1. Credit-Card, 2. Cash, 3. Cheque 
    applySearchClick() {
     //debugger
       this.pageNumber = 1;
        this.$refs.cp.loadInit();
      },
    //--$$**$$
  handleRole(){
    this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
    this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if(this.EmployeeRolesStr.length > 0){
        this.val = this.EmployeeRolesStr.filter(
        (i)=>i.name == 'Active Requests'
      );
        if(this.val[0].canUpdate == 0){ this.updButton = 0;}
        if(this.val[0].canDelete == 0){ this.delButton = 0;}
   }
  },

  loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
  },
     //Timer
   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    datePicker() {
      let ss = this;
      debugger;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          ss.startDate = new Date(start);
          ss.endDate = new Date(end);
          ss.initDate =
            ss.dateToMDY(ss.startDate) + " - " + ss.dateToMDY(ss.endDate);
        }
      );
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };
      
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";
     
      this.StartLogoutTime();
    },
    //code for Data-Tables_
    //-------------------- Common Methods
  
  }, // methods

  watch: {
    allPaymentRequests: function () {
       try {
      for (let i = 0; i < this.allPaymentRequests.length; i++) {
        let dd = new Date(this.allPaymentRequests[i].dob);
        this.allPaymentRequests[i].dob = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].dos);
        this.allPaymentRequests[i].dos = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].billDate);
        this.allPaymentRequests[i].billDate = dd.toLocaleDateString();
        this.allPaymentRequests[i].billDateDate = dd;

        this.allPaymentRequests[i].monthYear = this.dateToYM(dd);
        this.allPaymentRequests[i].dateFull = this.dateToYMD(dd);

        this.allPaymentRequests[i].oldStatus =
          this.allPaymentRequests[i].status;
         }
       }
      catch {
        /**/
      } finally {
        /**/
      this.filteredPaymentRequests = this.allPaymentRequests;
      this.performFilter();

      }
    },
  

    initDate: function (val) {
      debugger;
      if (val == "") return;
      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";

      this.$refs.cp.axiosGetData(url, this.dummyComm, 1);

      this.$refs.performFilter();
    },

    "filter.monthYear": function (val) {
      this.filter.monthYear = this.dateToYMD(new Date(val));

      this.intDummyComm();
      this.dummyComm.myTime = "my";
      this.dummyComm.extras1 = this.filter.monthYear;

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";

        this.$refs.cp.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
    },
  },

  mounted() {
    this.handleRole();
    this.$refs.cp.loadInit();
  }, // mounted
};
</script>

<style scoped>
.float-class:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 98%;
}
.float-class1:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 200px;
}
#font1{
    font-weight: 600;
    font-size: 15px;
    margin-top:-4.5px;
}

.float-class:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 98%;
}
.float-class1:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 200px;
}
#font1{
    font-weight: 600;
    font-size: 15px;
    margin-top:-4.5px;
}

  .float-textarea,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 1px solid rgb(235, 235, 235);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-textarea:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-class,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    /* border-bottom: 2px solid rgb(240, 141, 11); */
    border-bottom: 1px solid rgb(235, 235, 235);
    box-shadow: none;
  }

  .float-class:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    box-shadow: none;
  }

  #font1 {
    font-weight: bold;
    font-size: 15px;
    margin-left: -7px;
  }

  .label_select {
    margin-top: -23px;
    margin-left: 0px;
  }

  .activeColor {
    background-color: #fb9678;
    color: white;
  }

  .colorActive {
    color: #f95c2e
  }

  .disabledColor {
    color: gray;
    background: lightgrey;
  }

  .asc-desc-btn {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: honeydew;
    float: right;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #00c292;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #00c292;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    height: 34px;
    width: 56px;
    border-radius: 24px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .label-color {
    color: black;
  }
</style>